import { render, staticRenderFns } from "./ContractTemplate.vue?vue&type=template&id=567f9c06&scoped=true"
import script from "./ContractTemplate.vue?vue&type=script&lang=js"
export * from "./ContractTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f9c06",
  null
  
)

export default component.exports